import React, { useState } from "react";
import { useFormik } from "formik";
import * as YUP from "yup";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { Helmet } from "react-helmet";


export default function ForgetPassword() {
  let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  let forgetSchema = YUP.object({
    email: YUP.string()
      .matches(emailRegex, "Email is not matched, Please try again!")
      .required("Email is required"),
  });

  let navigate = useNavigate();
  const [error, seterror] = useState(null);
  const [isLodding, setisLodding] = useState(false);

  async function forgetPass(values) {
    setisLodding(true);
    let { data } = await axios
      .patch("https://vehex-production.up.railway.app/user/forget_code", values)
      .catch((err) => {
        setisLodding(false);
        seterror(err.response.data.message);
      });

    if (data.message === "You can reset your password now") {
      setisLodding(false);
      navigate("/resetPassword");
    }
  }

  let forgetPassword = useFormik({
    initialValues: {
      email: "",
    },
    forgetSchema,
    onSubmit: forgetPass,
  });

  return (
    <>
                                        <Helmet>
                      <title>Forget Password</title>
                    </Helmet>
      <div className="w-100 bg-black">
        <div className="image w-100 position-relative">
          <div className="overlay">
            <div className="container">
              <div className="w-50 py-4 submitContent box-shadow p-2 mt-2 position-absolute rounded-3">
                {error ? (
                  <div className="alert alert-danger">{error} try again!</div>
                ) : (
                  ""
                )}

                <h2 className="fw-600 mb-3 heading">
                  Forget Your Password ?
                </h2>
                <form onSubmit={forgetPassword.handleSubmit}>
                  <label htmlFor="email" className="fs-4 second-color mt-3">
                    Email :
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control fs-5"
                    value={forgetPassword.values.email}
                    onBlur={forgetPassword.handleBlur}
                    onChange={forgetPassword.handleChange}
                  ></input>
                  {forgetPassword.errors.email &&
                  forgetPassword.touched.email ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {forgetPassword.errors.email}
                    </div>
                  ) : (
                    ""
                  )}

                  {isLodding ? (
                    <button type="button" className="btn text-white py-3">
                      <RotatingLines
                        strokeColor="#c2272d"
                        strokeWidth="10"
                        animationDuration="1"
                        width="30"
                        visible={true}
                      />
                    </button>
                  ) : (
                    <>
                      <button
                        disabled={
                          !(forgetPassword.isValid && forgetPassword.dirty)
                        }
                        type="submit"
                        className="my-3 fw-500 border-2"
                      >
                        Send Code
                      </button>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
